import { render, staticRenderFns } from "./SettingsPassword.vue?vue&type=template&id=78ba930c&scoped=true"
import script from "./SettingsPassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./SettingsPassword.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SettingsPassword.vue?vue&type=style&index=0&id=78ba930c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ba930c",
  null
  
)

export default component.exports